import { useMemo } from "react";
import { AD_TYPES } from "../constants";
import { formatCurrency } from "utils/formatNumber";
import { useAppSelector } from "redux/hooks";
import { css } from "../../../../../../styled-system/css";
import { FaTriangleExclamation } from "react-icons/fa6";

const EXAMPLE_BID_BEFORE_COMPONDING_MULTIPLIERS = 1;

const PlacementModifierWarning = ({ state }) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const displayCompoundingModifierWarning =
    ([AD_TYPES.SPONSORED_PRODUCT.value, AD_TYPES.SPONSORED_PRODUCT_AUTO.value].includes(state.adType) &&
      [
        parseInt(state.topOfSearchBidMultiplier),
        parseInt(state.productPageMultiplier),
        parseInt(state.restOfSearchMultiplier),
      ].some((multiplier) => multiplier > 0)) ||
    ([AD_TYPES.SPONSORED_BRAND.value, AD_TYPES.SPONSORED_BRAND_V2.value].includes(state.adType) &&
      [state.homePlacementBidMultiplier, state.pagePlacementBidMultiplier, state.otherPlacementBidMultiplier].some(
        (multiplier) => parseInt(multiplier) > 0,
      ) &&
      [state.shopperSegmentBidMultiplier, state.audienceBidMultiplier].some((multiplier) => parseInt(multiplier) > 0));

  const maximumCompoundBid = useMemo(() => {
    if ([AD_TYPES.SPONSORED_PRODUCT.value, AD_TYPES.SPONSORED_PRODUCT_AUTO.value].includes(state.adType)) {
      const placementMaxBidPercent =
        1 + Math.max(state.topOfSearchBidMultiplier, state.productPageMultiplier, state.restOfSearchMultiplier) ?
          1 + Math.max(state.topOfSearchBidMultiplier, state.productPageMultiplier, state.restOfSearchMultiplier) / 100
        : 0;
      const audiencePercent = 1 + (state.audienceBidMultiplier ? state.audienceBidMultiplier / 100 : 0);
      const businessMultiplierPercent =
        1 + (parseInt(state.amazonBusinessMultiplier) ? parseInt(state.amazonBusinessMultiplier) / 100 : 0);

      const maxAmount =
        placementMaxBidPercent *
        audiencePercent *
        businessMultiplierPercent *
        EXAMPLE_BID_BEFORE_COMPONDING_MULTIPLIERS;
      return maxAmount;
    }

    if ([AD_TYPES.SPONSORED_BRAND.value, AD_TYPES.SPONSORED_BRAND_V2.value].includes(state.adType)) {
      const placementMaxBidPercent =
        1 +
        ((
          Math.max(
            state.homePlacementBidMultiplier,
            state.pagePlacementBidMultiplier,
            state.otherPlacementBidMultiplier,
          )
        ) ?
          Math.max(
            state.homePlacementBidMultiplier,
            state.pagePlacementBidMultiplier,
            state.otherPlacementBidMultiplier,
          ) / 100
        : 0);

      const audiencePercent = 1 + (state.audienceBidMultiplier ? state.audienceBidMultiplier / 100 : 0);
      const shopperSegmentMultiplierPercent =
        1 + (state.shopperSegmentBidMultiplier ? parseInt(state.shopperSegmentBidMultiplier) / 100 : 0);

      const maxAmount =
        placementMaxBidPercent *
        audiencePercent *
        shopperSegmentMultiplierPercent *
        EXAMPLE_BID_BEFORE_COMPONDING_MULTIPLIERS;
      return maxAmount;
    }
  }, [state]);

  if (!displayCompoundingModifierWarning) {
    return null;
  }

  return (
    <>
      <p className={css({ marginTop: "15px", color: "#6C757D", fontSize: "1.3rem", fontWeight: 500 })}>
        <FaTriangleExclamation className={css({ marginEnd: "xsmall" })} />
        This multiplier configuration may result in a {formatCurrency(1, marketPlace)} bid being modified as high as{" "}
        {formatCurrency(maximumCompoundBid, marketPlace)}.
      </p>
      <p className={css({ marginTop: "15px", color: "#6C757D", fontSize: "1.3rem", fontWeight: 500 })}>
        This considers the highest value out of the placement multipliers, compounded with Amazon{" "}
        {[AD_TYPES.SPONSORED_BRAND.value, AD_TYPES.SPONSORED_BRAND_V2.value].includes(state.adType) ?
          "segment"
        : "business"}{" "}
        and/or audience multipliers.
      </p>
    </>
  );
};

export default PlacementModifierWarning;
